import { PATHS } from '@/config/paths';
import type { HeaderNotificationSeed } from '@/features/notifications/types/headerNotification.types';

/**
 * Bản mẫu nội dung chuông — đồng bộ bản dịch `notifications.header.items` trong locale.
 */
export const HEADER_NOTIFICATION_SEED: readonly HeaderNotificationSeed[] = [
  {
    id: 'seed:n1',
    category: 'iot_threshold',
    severity: 'warning',
    titleKey: 'notifications.header.items.n1.title',
    timeKey: 'notifications.header.items.n1.time',
    recency: { unit: 'hour', value: 2 },
    actionKind: 'openIotStationDetail',
    iotStationNameContains: 'Hồng',
    actionPath: PATHS.MAP_IOT,
  },
  {
    id: 'seed:n2',
    category: 'data_sync',
    severity: 'info',
    titleKey: 'notifications.header.items.n2.title',
    timeKey: 'notifications.header.items.n2.time',
    recency: { unit: 'day', value: 1 },
    actionPath: PATHS.MAP_IOT,
  },
  {
    id: 'seed:n3',
    category: 'report',
    severity: 'info',
    titleKey: 'notifications.header.items.n3.title',
    timeKey: 'notifications.header.items.n3.time',
    recency: { unit: 'day', value: 1 },
    actionPath: PATHS.OPS_REPORTS_OVERVIEW,
  },
  {
    id: 'seed:n4',
    category: 'maintenance',
    severity: 'info',
    titleKey: 'notifications.header.items.n4.title',
    timeKey: 'notifications.header.items.n4.time',
    recency: { unit: 'day', value: 3 },
    actionPath: PATHS.OPS_STATIONS,
  },
];
